import cls from "./AboutPage.module.scss";
import astrology from "shared/assets/images/appIcon/AI_Astrology.png";
import astrologyCreative1 from "shared/assets/creative/astrology/astrologyCreative1.png";
import astrologyCreative2 from "shared/assets/creative/astrology/astrologyCreative2.png";
import astrologyCreative3 from "shared/assets/creative/astrology/astrologyCreative3.png";
import {classNames} from "shared/lib/classNames/classNames";
import {AppDetails} from "shared/ui/AppDetails/AppDetails";

enum LinkType {
    APP_STORE = "APP_STORE",
    GOOGLE_PLAY = "GOOGLE_PLAY",
}

export const AboutPage = () => {
    return (
        <div id="aboutPage">
            <section
                className={classNames("page-section", {}, [cls.appsPage__app])}
            >
                <div className={classNames("container container__main", {}, [])}>
                    <div className={classNames(cls.App, {}, [])}>
                        <AppDetails app={{
                            img: astrology,
                            title: ["AI Astrology", "Horoscope Today"],
                            id: "ai-astrology",
                            creative: [astrologyCreative1, astrologyCreative2, astrologyCreative3],
                            description: "Unlock cosmic insights & love predictions with AI Astrology! Get personalized\n" +
                                "                                        horoscopes, daily guidance & more.",
                            purpose: `AI Astrology: Horoscope Today, the ultimate mobile app for daily horoscope insights and astrological guidance. 

Whether you're seeking advice on love, career, or personal growth, our app delivers personalized horoscopes tailored just for you.`,
                            links: {
                                [LinkType.APP_STORE]: "https://apps.apple.com/ru/app/ai-astrology-%D0%B3%D0%BE%D1%80%D0%BE%D1%81%D0%BA%D0%BE%D0%BF-%D0%BD%D0%B0-%D0%B4%D0%B5%D0%BD%D1%8C/id6474508082",
                                [LinkType.GOOGLE_PLAY]: "https://play.google.com/store/apps/details?id=com.horolite.horoscope"
                            }
                        }}/>
                    </div>
                </div>
            </section>
        </div>
    )
}
